import { NotificationLog } from '@/interfaces';
import { ReportSearch, VerificationSearch } from '@/models';
import { Helper } from '@/services/helper';
import * as A from '@/store/mutation-types';
import axios from 'axios';
import { Store } from 'vuex';

import { HttpService } from './http.service';

export class SleuthApiService {
  constructor(
    public store: Store<any>,
    public http: HttpService,
    public helper: Helper
  ) {}
  public searchProviders(name?: string) {
    if (!name) {
      name = '';
    }

    return this.http
      .get(`/Sleuth/Administration/Providers?name=${name}`)
      .then(resp => {
        this.store.commit(A.SET_PROVIDERS, resp.data.data);
      });
  }
  public saveProvider() {}
  public listProviderMappings() {}
  public saveMapping() {}
  public getBuildVersion() {
    return this.http
      .get(`/Sleuth/Administration/Build`)
      .then(resp => this.store.commit(A.SET_BUILD_VERSION, resp.data.data));
  }
  public searchReport(command: ReportSearch) {
    const qs = this.helper.serialize(command);
    return this.http
      .get(`/Sleuth/Report?${qs}`)
      .then(resp => this.store.commit(A.SET_REPORTS, resp.data.data));
  }
  public retrieveReport(requestid: string) {
    return this.http
      .get(`/Sleuth/Report/${requestid}`)
      .then(resp => this.store.commit(A.SET_REPORT_DETAILS, resp.data.data));
  }
  public retrieveVolunteerVerification(
    instanceKey: string,
    portalId: number,
    volunteerId: number
  ) {
    return this.http
      .post('/Sleuth/Volunteer/Retrieve', {
        instanceKey: instanceKey,
        portalId: portalId,
        volunteerId: volunteerId
      })
      .then(resp => this.store.commit(A.SET_VERIFICATION, resp.data.data));
  }
  public loadVolunteerVerifications(command: VerificationSearch) {
    return this.http
      .post('/Sleuth/Volunteer/Load', command)
      .then(resp => this.store.commit(A.SET_VERIFICATIONS, resp.data.data));
  }
  public getPostBackErrorLogs(status: number, page: number, pageSize: number) {
    return this.http
      .post(`/Sleuth/Administration/PostbackErrorLogs`, {
        pageNumber: page || 0,
        pageSize: pageSize || 25,
        status: status || 200
      })
      .then(resp =>
        this.store.commit(A.SET_POSTBACK_ERROR_LOGS, resp.data.data)
      );
  }
  public updateAll() {
    return axios({
      url: `/Sleuth/Administration/UpdateStatus`,
      method: 'POST'
    })
      .then(resp => {
        return resp.data.data;
      })
      .catch(err => {
        return err;
      });
  }
  public getStatus(id) {
    return axios({
      url: `/Sleuth/Administration/Update/${id}`,
      method: 'POST'
    })
      .then(resp => {
        return resp.data.data;
      })
      .catch(err => {
        return err;
      });
  }
  public setErrorLog(log: NotificationLog) {
    return this.store.commit(A.SET_POSTBACK_ERROR_LOG, log);
  }

  public truncatePostbackLogs() {
    return this.http
      .delete(`/Sleuth/Administration/PostbackErrorLogs`)
      .then(resp =>
        this.store.commit(A.SET_POSTBACK_ERROR_LOGS, { count: 0, logs: [] })
      );
  }
}
